export enum ProviderEnum {
	CURRENT_PROVIDER = 'current',
	NEW_PROVIDER = 'new',
}
